var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{ref:"input",style:({width: _vm.width}),attrs:{"value":_vm.currentValue,"size":_vm.size,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"blur":_vm.handleBlur,"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }